export default {
  placeholders: {
    zipCode: 'Zip Code',
    region: 'Region',
    state: 'State',
    district: 'District',
    city: 'City',
  },
};
